import { FC } from 'react';
import {
  PageInfo,
  PageSizeSelect,
  PaginationButton,
  PaginationFooter,
  PaginationLeft,
  PaginationRight
} from './styles';

interface CustomPaginationProps {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

const CustomPagination: FC<CustomPaginationProps> = ({
  currentPage,
  pageSize,
  totalItems,
  onPageChange,
  onPageSizeChange
}) => {
  const totalPages = Math.ceil(totalItems / pageSize);
  const startRow = currentPage * pageSize + 1;
  const endRow = Math.min((currentPage + 1) * pageSize, totalItems);

  const handlePreviousPage = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageSizeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newPageSize = parseInt(event.target.value);
    onPageSizeChange(newPageSize);
  };

  return (
    <PaginationFooter>
      <PaginationLeft>
        <span>Rows per page:</span>
        <PageSizeSelect value={pageSize} onChange={handlePageSizeChange}>
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={25}>25</option>
        </PageSizeSelect>
      </PaginationLeft>

      <PaginationRight>
        <PageInfo>
          {startRow}-{endRow} of {totalItems}
        </PageInfo>
        <PaginationButton type="button" onClick={handlePreviousPage} disabled={currentPage === 0}>
          <img src="/assets/images/chevronLeft.svg" alt="Previous" width="24" height="24" />
        </PaginationButton>
        <PaginationButton
          type="button"
          onClick={handleNextPage}
          disabled={currentPage >= totalPages - 1}
        >
          <img src="/assets/images/chevronRight.svg" alt="Next" width="24" height="24" />
        </PaginationButton>
      </PaginationRight>
    </PaginationFooter>
  );
};

export default CustomPagination;
